<template>
  <el-dialog title="Masini" :visible.sync="showPopup" id="popup_dialog" width="90%" class="my-dialog-class">
    <el-form label-position="top" :inline="false" :rules="rules" label-width="100%" :model="selectedObject"
      ref="my-form" @submit.prevent="save" v-loading="loadingVisible">
      <el-row :gutter="15">
        <el-col :md="8">
          <el-form-item prop="IdClient" label="Client">
            <div class="input-group full-width">
              <el-select class="semi-full-width" v-model="selectedObject.IdClient" filterable remote reserve-keyword
                placeholder="Search for client" :remote-method="searchClients" :loading="loadingClients">
                <el-option v-for="item in Info.clienti" :key="'clienti' + item.Id" :label="item.Nume"
                  :value="item.Id"></el-option>
              </el-select>
              <div class="input-group-append">
                <el-button plain type="success" icon="el-icon-plus" @click="show_add_new_client()"
                  class="success"></el-button>
              </div>
            </div>
          </el-form-item>
        </el-col>

        <el-col :md="8">
          <el-form-item prop="Numar" label="Numar">
            <el-input class="full-width" v-model="selectedObject.Numar" />
          </el-form-item>
        </el-col>
        <el-col :md="8">
          <el-form-item prop="Marca" label="Marca">
            <el-select class="full-width" @change="load_model_marca(selectedObject.Marca)"
              v-model="selectedObject.Marca" placeholder="Alege marca" filterable>
              <el-option v-for="marca in Marci" :key="'marca_' + marca.Id" :label="marca.Nume"
                :value="marca.Id"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :md="8">
          <el-form-item prop="Model" label="Model">

            <div class="input-group full-width">
              <el-select @change="onModelChange(selectedObject.Model)" class="semi-full-width" :disabled="Model.length <= 0"
                v-model="selectedObject.Model" placeholder="Alege modelul" filterable>
                <el-option v-for="model in Model" :key="'model_' + model.Id" :label="model.Nume" :value="model.Id" />
              </el-select>
              <div class="input-group-append">
                <el-button :disabled="Model.length <= 0" plain type="success" icon="el-icon-plus"
                  @click="show_add_new_model()" class="success"></el-button>
              </div>
            </div>
          </el-form-item>
        </el-col>
        <el-col :md="8">
          <el-form-item prop="An" label="An">
            <el-date-picker class="full-width" value-format="yyyy" type="year" :picker-options="datePickerOptions"
              v-model="selectedObject.An" placeholder="Selecteaza anul">
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :md="8">
          <el-form-item prop="TipAuto" label="Tip auto">
            <el-select v-model="selectedObject.TipAuto" class="full-width">
              <el-option label="Normal" value="Normal"></el-option>
              <el-option label="SUV" value="SUV"></el-option>
              <el-option label="Autoutilitar" value="Autoutilitar"></el-option>
              <el-option label="Supercar" value="Supercar"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :md="8">
          <el-form-item prop="Km" label="Km">
            <el-input class="full-width" v-model="selectedObject.Km" />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="showPopup = false"> Renunta </el-button>
      <el-button type="primary" @click="save()"> Salveaza </el-button>
    </span>
    <Clienti-dialog ref="dlg-client-nou" @save="salvare_client()" />
    <Model-dialog ref="dlg-model-nou" @save="salvare_model()" />
  </el-dialog>
</template>

<script>
import settings from "@/backend/LocalSettings";
import BasePage from "@/pages/Admin/BasePage";
import Clienti_dialog from "@/pages/Admin/clienti/Clienti_dialog.vue";
import Model_dialog from "@/pages/Admin/tipuri_masini/Tipuri_masini_dialog.vue";

export default {
  name: "Masini_dialog",
  extends: BasePage,
  components: {
    "Clienti-dialog": Clienti_dialog,
    "Model-dialog": Model_dialog,
  },
  data() {
    let validNumar = (rule, value, callback) => {

      if (typeof value != 'undefined') value = value.replaceAll(' ', '');

      if (value == undefined) {
        callback('Campul este obligatoriu');
        return;
      }

      this.selectedObject.Numar = value.toUpperCase();
      if (value.length < 3) callback('Numarul trebuie sa aiba cel putin 3 caractere');
      let regex = /(([0-9]+[A-Z]+)|([A-Z]+[0-9]+))/
      if (!regex.test(value)) {
        callback('Numarul trebuie sa aiba cel putin o litera si o cifra');
      } else {
        callback();
      }
    }

    let formatNumarKm = (rule, value, callback) => {
      if (value == null || value == '') return callback();
      this.selectedObject.Km = value.split("").filter(a => /^\d+$/.test(a)).join("");
      callback();
    }
    return {
      baseUrl: "",
      showPopup: false,
      mode: "add",
      Marci: [],
      Model: [],
      nrDevize: 0,
      warningMsg: null,
      initialCarNr: '',
      selectedObject: {
        IdClient: "",
        Numar: "",
        Model: "",
        Marca: "",
        An: "",
        TipAuto: "Normal",
      },
      Info: {
        clienti: [],
      },
      loadingClients: false,
      rules: {
        IdClient: [{ required: true, message: "Campul este obligatoriu" }],
        Numar: [{ required: true, validator: validNumar }],
        TipAuto: [{ required: true, message: "Campul este obligatoriu" }],
        Km: [{ required: false, validator: formatNumarKm }]
      },
      datePickerOptions: {
        disabledDate(date) {
          return date > new Date();
        }
      },
    };
  },
  methods: {
    show_add_new_client() {
      this.$refs["dlg-client-nou"].show_me();
    },
    show_add_new_model() {
      this.$refs["dlg-model-nou"].show_me_cu_marca(this.selectedObject.Marca);
    },
    async searchClients(query) {
      if (!query) {
        this.Info.clienti = [];
        return;
      }
      this.loadingClients = true;

      try {
        var result = await this.post("admin/masini/search_client", {
          query: query,
        });

        this.Info.clienti = result.clienti;
      } catch (error) {
        console.error("Error fetching clients:", error);
      } finally {
        this.loadingClients = false;
      }
    },
    show_me: async function (id) {
      this.get_info();

      this.Model = [];
      if (id == null) {
        this.mode = "add";
        this.selectedObject = {
          IdClient: "",
          Numar: "",
          Model: "",
          Marca: "",
          An: "",
          Km: "",
          TipAuto: "Normal",
        };
      } else {
        this.mode = "edit";
        var result = await this.post("admin/masini/get_info_item_dialog", {
          id: id,
        });
        this.initialCarNr = this.selectedObject.Numar;

        await this.load_model_marca(result.Item.Marca);
        this.selectedObject = result.Item;
      }

      this.showPopup = true;
    },
    async salvare_client() {
      this.get_info();
      var response = await this.post('admin/clienti/get_last_client', {})
      this.selectedObject.IdClient = response.LastClientId
      this.numeClient = response.NumeClient
    },
    async salvare_model() {
      this.get_info();
      var response = await this.post('tipuri_masini/get_last_model', {})
      this.Model = [];
      this.load_model_marca(this.selectedObject.Marca)
      this.$set(this.selectedObject, 'Model', response.NumeModel)

    },
    async get_info() {
      var response = await this.post("admin/masini/get_info_for_dialog");
      this.Info.clienti = response.clienti;
      this.Marci = response.marci;
    },

    load_model_marca: async function (Marca) {
      this.Model = [];
      this.$set(this.selectedObject, 'Model', '')
      this.$set(this.selectedObject, 'TipAuto', 'Normal');
      let args = { IdMarca: Marca };
      let response = await this.post("admin/masini/get_tipuri_marca", args);
      if (response.tipuri) this.Model = response.tipuri;
    },

    onModelChange: function (selectedModelId) {
      if (!selectedModelId) {
        this.selectedObject.TipAuto = 'Normal';
        return;
      }

      const selectedModel = this.Model.find(model => model.Id === selectedModelId);

      if (selectedModel && selectedModel.Tip) {
        const validTypes = ['Normal', 'SUV', 'Autoutilitar', 'Supercar'];

        if (validTypes.includes(selectedModel.Tip)) {
          this.selectedObject.TipAuto = selectedModel.Tip;
        } else {
          this.selectedObject.TipAuto = 'Normal';
        }
      } else {
        this.selectedObject.TipAuto = 'Normal';
      }
    },

    async save() {
      try {
        if (this.selectedObject.Id) {
          const result = await this.post("admin/masini/get_numar_devize_masina", { idMasina: this.selectedObject.Id })

          if (result && result.NumarDevize) {
            this.nrDevize = result.NumarDevize;
            if (this.nrDevize && this.nrDevize != 0) {
              this.warningMsg = 'Numarul masinii se afla pe ' + this.nrDevize + ' deviz/e, modificam numarul de inmatriculare si de pe ele?'
            } else {
              this.warningMsg = null;
            }
          }
        }

        this.$refs["my-form"].validate(async (valid) => {
          if (valid) {
            if (this.warningMsg && this.mode == 'edit' && this.initialCarNr !== this.selectedObject.Numar) {
              this.$confirm(this.warningMsg, 'Atentie', { confirmButtonText: 'Da', cancelButtonText: 'Nu', type: 'warning' })
                .then(async () => {
                  await this.saveMasinaHandler(true);
                })
                .catch(async () => {
                  await this.saveMasinaHandler(false);
                  this.$message({ type: 'info', message: 'Numarul de pe devize nu a fost modificat!' });
                });
            } else if ((!this.warningMsg && this.mode == 'edit') ||
              (this.mode == 'add') ||
              (this.warningMsg && this.mode == 'edit' && this.initialCarNr === this.selectedObject.Numar)) {
              await this.saveMasinaHandler(false)
            }
          }
        });
      } catch (error) {
        console.error(error)
      }
    },

    async saveMasinaHandler(isDeviz) {
      try {
        const response = await this.post("admin/masini/save", {
          mode: this.mode,
          object: this.selectedObject,
          isDeviz: isDeviz,
        });
        if (response.success) {
          this.$message({ message: "Masina a fost modificata cu succes!", type: "success", });
          this.selectedObject = {};
          this.$emit("save");

          this.showPopup = false;
        } else {
          this.$message({ message: response.message, type: "error", });
        }
      } catch (error) {
        console.error(error);
        this.$message({ message: 'A intervenit o problema in modificarea masinii!', type: "error", });
      }
    }
  },
  mounted: function () {
    this.baseUrl = settings.BASE_URL;
    this.get_info();
    // this.load_marci();
  },
};
</script>

<style lang="less" scoped>
.full-width {
  width: 100%;
}

.semi-full-width {
  width: 80%;
}
</style>